export default __webpack_public_path__ + "static/media/Dmitri-Particle_0007_StompImpactDust.fcd6ae2a.png";